document.addEventListener("DOMContentLoaded", (event) => {
  let productImagesDiv = document.getElementById("product-image-data");
  if (productImagesDiv) {
    let imagesArray = JSON.parse(productImagesDiv.getAttribute("data-images"));
    let section = document.getElementById(productImagesDiv.getAttribute('data-section-id'));


    
    document.addEventListener("variant:changed", function (e) {
      let variant = e.detail.variant;
      let variantOptions = variant.options.map((v) => v.toLowerCase());
      let imagesContainer = section.querySelectorAll(
        "product-media flickity-carousel .product__media-item"
      );



      let imagesThumbContainer = section.querySelector(
        "product-media .product__thumbnail-list-inner"
      );

      let flickityElement = section.querySelector('flickity-carousel[data-pdp]');

      let buttonThumbContainer = section.querySelector("product-media .dots-nav");

      //Loop all Metafield Arrays

      imagesArray.forEach((imageTags, arrayIndex) => {
        if (imageTags !== "all") {
          let show = true;
          let imageOptions = imageTags.split("_");
            imageOptions.forEach((imageOption, index) => {
              if(imageOption !== "all" && imageOption.toLowerCase() !== variantOptions[index]){
                show = false;
              }
            });  

          let productImage = section.querySelector(`[data-original-position="${arrayIndex}"]`);
          
          if(show){
          if(productImage){
            productImage.classList.remove('is-filtered');
          }
          imagesThumbContainer.children[arrayIndex].classList.remove('is-filtered');
          buttonThumbContainer.children[arrayIndex].classList.remove('is-filtered');
          }
          else{
            if(productImage){
            productImage.classList.add('is-filtered');
            }
           imagesThumbContainer.children[arrayIndex].classList.add('is-filtered');
          buttonThumbContainer.children[arrayIndex].classList.add('is-filtered');
          }

        }
      });
    });
  }
});


class ShippingProtection extends HTMLElement {
  constructor() {
    super();
    this.initialAdded = this.closest("cart-drawer").getAttribute("data-has-protection");
    this.isProtectionAdded = localStorage.getItem('shippingProtectionAdded') === 'true';
  }

  // Called when the component is connected to the DOM
  connectedCallback() {
    this.productId = Number(this.getAttribute('data-product-id'));
    this.toggleInput = this.querySelector('#protection-toggle');
    
    if (this.initialAdded === 'false' && localStorage.getItem('shippingProtectionAdded') === null) {
      this.addShippingProtection();
    } else {
      // console.log("already added or removed in past");
    }

    this.toggleInput.addEventListener('change', this.toggleChange.bind(this));
  }

  // Handle toggle change events
  toggleChange(event) {
    if (this.toggleInput.checked && this.initialAdded === 'false') {
      this.addShippingProtection();
    } else {
      this.removeShippingProtection();
    }
  }

  // Add shipping protection product to the cart
  addShippingProtection() {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: this.productId, quantity: 1 }]
      })
    })
    .then(response => response.json())
    .then(data => {
      // console.log('Shipping protection added:', data);
      localStorage.setItem('shippingProtectionAdded', 'true');
      this.isProtectionAdded = 'true';
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
    })
    .catch(error => console.error('Error adding shipping protection:', error));
  }

  // Remove shipping protection product from the cart
  removeShippingProtection() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // console.log(cart);
        // console.log(this.productId);
        const item = cart.items.find(item => item.id === this.productId);
        // console.log(item.id);
        if (item) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          });
        } else {
          throw new Error('Shipping protection not found in cart');
        }
      })
      .then(response => response.json())
      .then(data => {
        // console.log('Shipping protection removed:', data);
        this.isProtectionAdded = 'false';
        localStorage.setItem('shippingProtectionAdded', 'false');
        document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
      })
      .catch(error => console.error('Error removing shipping protection:', error));
  }

  // Clean up event listener when the component is disconnected
  disconnectedCallback() {
    this.toggleInput.removeEventListener('change', this.toggleChange);
  }
}

// Register the custom element
customElements.define('shipping-protection', ShippingProtection);


// class WFShippingProtection extends HTMLElement{}

// customElements.define("wf-shipping-protection",WFShippingProtection);